module.exports = __webpack_public_path__ + "static/media/edit-icon.8c97681a.svg";